import { DateTime } from 'luxon';
import { FlowExecutionState } from '../../enums/flow-execution-state';

export class ExecutionHistoryStub {
	id!: string;
	executionID!: string;
	executionState: FlowExecutionState = FlowExecutionState.PendingExecution;
	isSimulation: boolean = false;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	runTime: string = '';
	error: string = '';
	flowVersion = '';
	iHubVersion = '';

	constructor(executionHistoryProps: Partial<ExecutionHistoryStub>) {
		Object.assign(this, executionHistoryProps);
	}
}
